import { Select } from 'antd'
import { Form } from 'antd'
import { FC, useEffect } from 'react'
import { useLazyGetStampsQuery } from '../../../store/api/stamps-api'
import { EndpointQueryParameters } from '../../../types/strapi/strapi'
import _ from 'lodash'
import useFormInstance from 'antd/es/form/hooks/useFormInstance'
import { requiredRules } from '../../../constants/forms/validation/rules'

interface StampProps {
    noStyle?: boolean
}

const Stamp: FC<StampProps> = ({ noStyle }) => {
    const name = 'stamp'
    const form = useFormInstance()
    const [get, state] = useLazyGetStampsQuery()

    const onSearch = _.debounce(async (query: string) => {
        if (query.length < 1) return
        const params: EndpointQueryParameters = { filters: { number: { $contains: query } } }
        await get(params)
    }, 500)

    useEffect(() => {
        if (form.getFieldValue('stamp')) {
            get({ filters: { documentId: { $eq: form.getFieldValue(name) } } })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Form.Item name={name} label={'Штамп'} rules={requiredRules} noStyle={noStyle}>
            <Select
                options={state.data?.data.map(item => ({
                    value: item.documentId,
                    label: `№ ${item.number} (${item.length} x ${item.width})`,
                }))}
                filterOption={() => true}
                onSearch={onSearch}
                showSearch
                popupMatchSelectWidth={160}
            />
        </Form.Item>
    )
}

export default Stamp
